// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarPeriodosByCotaUsuario = async (
  cotaUsuario: number | undefined | null
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${cotaUsuario}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        console.log("Response data 1:", response.data);
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
